function Comments() {
    this.node = null;
    this.id = null;
    this.declaredClass = null;
    this.extends = [_ResponsiveLayout];

    this._state = "mobile";

    this.init = function() {
        $(this.node).css("display", "block");

        // Connections
        $("#comment-btn").on("click", $.proxy(this._onClickShow, this));
        this.registerResponsiveFunction($.proxy(this.resize, this, "mobile"), null, window.mogo.registry.mogoUI.config.mediaQueries.small);
        this.registerResponsiveFunction($.proxy(this.resize, this, "other"), window.mogo.registry.mogoUI.config.mediaQueries.small + 1, null);
    };

    this.initAllReady = function() {};

    this._onClickShow = function() {
        var disqusThread = $("#disqus_thread")[0];
        var commentBtn = $("#comment-btn");
        $(disqusThread).css("display", "none");
        $(disqusThread).removeClass("hide-for-small-only");
        $(commentBtn).removeClass("show-for-small-only");

        $(commentBtn).slideUp(350);
        $(disqusThread).slideDown(350);
    };

    this.resize = function(type) {
        if (type == "other" && this._state == "mobile") {
            $("#related-posts-container").insertBefore($("#comments-container"));
            this._state = "other";
        } else if (type == "mobile" && this._state == "other") {
            $("#comments-container").insertBefore($("#related-posts-container"));
            this._state = "mobile";
        }
    };
}